import React from 'react';
function VorteileBlock({
  items
}: {
  items: string[];
}) {
  return <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4" data-id="element-210">
      <p className="font-semibold text-green-800 mb-3 flex items-center gap-2" data-id="element-211">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-green-600 text-white text-xs" data-id="element-212">
          ✓
        </span>
        Vorteile
      </p>
      <ul className="list-none ml-0 space-y-2" data-id="element-213">
        {items.map((item, i) => <li key={i} className="flex items-start gap-2 text-green-900" data-id="element-214">
            <span className="text-green-500 mt-0.5 shrink-0" data-id="element-215">+</span>
            <span data-id="element-216">{item}</span>
          </li>)}
      </ul>
    </div>;
}
function NachteileBlock({
  items
}: {
  items: string[];
}) {
  return <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4" data-id="element-217">
      <p className="font-semibold text-amber-800 mb-3 flex items-center gap-2" data-id="element-218">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-amber-500 text-white text-xs" data-id="element-219">
          !
        </span>
        Nachteile
      </p>
      <ul className="list-none ml-0 space-y-2" data-id="element-220">
        {items.map((item, i) => <li key={i} className="flex items-start gap-2 text-amber-900" data-id="element-221">
            <span className="text-amber-500 mt-0.5 shrink-0" data-id="element-222">–</span>
            <span data-id="element-223">{item}</span>
          </li>)}
      </ul>
    </div>;
}
export function ComparisonSection() {
  return <div className="my-12" data-id="element-224">
      <h3 className="text-2xl font-bold text-[#1B1B2F] mb-8 border-b pb-2" data-id="element-225">
        Vergleich bekannter age-optimierter Marken
      </h3>

      {/* 1. Geroton */}
      <div className="mb-10" data-id="element-226">
        <h4 className="text-xl font-bold text-[#1B1B2F] mb-3" data-id="element-227">
          <a href="https://geroton.de/" target="_blank" rel="noopener noreferrer" className="underline decoration-[#2563EB]/40 underline-offset-2 hover:decoration-[#2563EB] transition-colors duration-200 inline-flex items-center gap-1.5 text-[#1B1B2F]" data-id="element-228">
            1. Geroton
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="inline-block shrink-0 opacity-70" data-id="element-229">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" data-id="element-230" />
              <polyline points="15 3 21 3 21 9" data-id="element-231" />
              <line x1="10" y1="14" x2="21" y2="3" data-id="element-232" />
            </svg>
          </a>
        </h4>
        <p className="mb-4 text-lg leading-relaxed text-[#1B1B2F]" data-id="element-233">
          Geroton ist eine spezialisierte Marke, die sich ausschließlich auf
          Nahrungsergänzungsmittel für Menschen ab 50 konzentriert. Das Konzept
          der Marke basiert nicht auf einzelnen Vitaminen, sondern auf einem
          System miteinander verbundener Formeln, die für eine langfristige und
          ausgewogene Anwendung berechnet sind.
        </p>
        <VorteileBlock items={['Reine und durchdachte Formeln mit hoher Bioverfügbarkeit', 'Komponenten ergänzen einander und bilden ein einheitliches Unterstützungssystem', 'Gute Verträglichkeit bei regelmäßiger Anwendung', 'Spürbarer Effekt bei regelmäßiger Nutzung', 'Orientierung genau auf das Alter 50+, statt einer universellen Zusammensetzung', 'Möglichkeit eines Abonnements mit monatlicher Lieferung, was den Erhalt frischer Produkte ermöglicht']} data-id="element-234" />
        <NachteileBlock items={['Keine Großpackungen für ein halbes Jahr im Voraus (der Hersteller produziert kleinere Chargen, um die Stabilität zu erhalten und den Inhalt vor Luftkontakt zu schützen)', 'Begrenzte Auswahl an Geschmacksrichtungen und Formen']} data-id="element-235" />
      </div>

      {/* 2. Vrodexi */}
      <div className="mb-10" data-id="element-236">
        <h4 className="text-xl font-bold text-[#1B1B2F] mb-3" data-id="element-237">2. Vrodexi</h4>
        <p className="mb-4 text-lg leading-relaxed text-[#1B1B2F]" data-id="element-238">
          Vrodexi ist eine Marke, die auf die Altersgruppe 50+ ausgerichtet ist,
          mit Schwerpunkt auf Geschmacksvielfalt und Bequemlichkeit bei der
          täglichen Einnahme. Viele Produkte sind in verschiedenen
          Geschmacksrichtungen erhältlich, was die regelmäßige Einnahme
          komfortabler macht. Die Linie umfasst Basis-Nährstoffe für die
          unterstützende Anwendung, mit der Möglichkeit, Ergänzungen je nach
          individuellen Vorlieben und Bedürfnissen selbst zu kombinieren.
        </p>
        <VorteileBlock items={['Vielfalt an Geschmacksrichtungen und Einnahmeoptionen', 'Bequemes tägliches Format', 'Breite Auswahl an Produkten im Sortiment', 'Einfache Kombination einzelner Ergänzungen']} data-id="element-239" />
        <NachteileBlock items={['In vielen Produkten wird Magnesiumstearat als Hilfsstoff verwendet, den ein Teil der Verbraucher lieber vermeidet', 'Nicht alle Nährstoffe liegen in den bioverfügbarsten Formen vor', 'Produkte wurden einzeln entwickelt und nicht als einheitliche Systemformel']} data-id="element-240" />
      </div>

      {/* 3. Grintuvo */}
      <div className="mb-10" data-id="element-241">
        <h4 className="text-xl font-bold text-[#1B1B2F] mb-3" data-id="element-242">3. Grintuvo</h4>
        <p className="mb-4 text-lg leading-relaxed text-[#1B1B2F]" data-id="element-243">
          Grintuvo ist eine weitere Marke, die auf das Alter 50+ ausgerichtet
          ist, mit Schwerpunkt auf großen Packungen und langfristigem Vorrat.
        </p>
        <VorteileBlock items={['Große Behältervolumina (langfristiger Vorrat ohne häufige Einkäufe)', 'Altersorientierte Basisformeln', 'Bequeme Lagerung', 'Stabile Standardzusammensetzung']} data-id="element-244" />
        <NachteileBlock items={['Zusammensetzung weniger „minimalistisch" als bei spezialisierteren Formeln',, 'Verträglichkeit kann individuell variieren', 'Die meisten Formeln sind nicht als einheitliches System aufgebaut und auf einen allgemeinen unterstützenden Effekt ausgerichtet']} data-id="element-245" />
      </div>
    </div>;
}